package com.flowyride.data.speedcameras.datagouv

import kotlinx.serialization.Serializable
import kotlinx.serialization.json.JsonObject

@Serializable
internal data class TabularPage(
    /** Rows are kept raw: column names come straight from the CSV header (odd spacing included). */
    val data: List<JsonObject> = emptyList(),
    val meta: TabularMeta = TabularMeta(),
)

@Serializable
internal data class TabularMeta(
    val page: Int = 1,
    val total: Int = 0,
)
